import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveLovemoSeo } from "@/seo/lovemoSeo";
import { buildLovemoJsonLd } from "@/seo/lovemoSchema";

const LOVEMO_JSONLD_ID = "lovemo-jsonld";

export default function LovemoSchemaManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = resolveLovemoSeo(pathname);
    const data = buildLovemoJsonLd(seo.schemaKind);
    const existing = document.getElementById(
      LOVEMO_JSONLD_ID,
    ) as HTMLScriptElement | null;

    if (!data) {
      if (existing) existing.remove();
      return;
    }

    const el = existing ?? document.createElement("script");
    el.id = LOVEMO_JSONLD_ID;
    el.setAttribute("type", "application/ld+json");
    el.textContent = JSON.stringify(data);

    if (!existing) {
      document.head.appendChild(el);
    }
  }, [pathname]);

  return null;
}